import photo1 from "../../../assets/images/appImages/Avatar.png";

export const TeamData = [
  {
    id: 1,
    photo: photo1,
    name: "Modou awa balla Lo",
    role: "Fondateur",
  },
  {
    id: 2,
    photo: photo1,
    name: "Ndene Sene",
    role: "Gestion des commandes",
  },
  {
    id: 3,
    photo: photo1,
    name: "Ibrahima Willier",
    role: "Gestion des commandes",
  },

]
